<template>
  <header class="header">
    <router-link to="/"><img class="ohelvas-icon" src="@/assets/icon-simple.svg"></router-link>
    <section class="sidebar">
      <div class="sidebar-icons-container">
        <router-link to="/estalagem#restaurante" class="sidebar-icon-container">
          <div class="icon"><img src="@/assets/ic-white-onde-comer.svg"></div>
          <p>Onde Comer</p>
        </router-link>
        <router-link to="/estalagem#hotel" class="sidebar-icon-container">
          <div class="icon"><img src="@/assets/ic-white-onde-dormir.svg"></div>
          <p>Onde Dormir</p>
        </router-link>
        <router-link to="/pontosDeInteresse?type=o_que_visitar" class="sidebar-icon-container">
          <div class="icon"><img src="@/assets/ic-white-o-que-visitar.svg"></div>
          <p>O que Visitar</p>
        </router-link>
        <router-link to="/pontosDeInteresse?type=onde_comprar" class="sidebar-icon-container">
          <div class="icon"><img src="@/assets/ic-white-ponde-comprar.svg"></div>
          <p>Onde Comprar</p>
        </router-link>
      </div>
      <div class="arrow">
        <img src="@/assets/arrow.svg">  
      </div> 
    </section>
    <slot>
      <div class="header-interior">
        <img class="background-image" :src="backgroundImage">
        <div class="overlay" />
        <div class="text-container">
          <img class="icon" :src="icon">
          <h1>{{heading}}</h1>
        </div>
        <section class="scroll-down" v-if="scroll === true" @click="scrollDown()">
          <p>Scroll down</p>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fill-rule="nonzero">
              <path d="M0 0h24v24H0z"/>
              <path fill="#FFF" d="M13 0v19.918L22.538 10 24 11.52 13 22.958V23h-.04L12 24l-.962-1H11v-.04L0 11.52 1.462 10 11 19.92V0h2z"/>
            </g>
          </svg>
        </section>
      </div>
    </slot>
  </header>
</template>
<script>

export default {
  name: 'heading',
  props: {
    heading: {
      default: null
    },
    icon: {
      default: null
    },
    backgroundImage: {
      default: null
    },
    scroll: {
      default: true
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
    scrollDown () {
      window.scrollTo({left: 0, top: window.innerHeight, behavior: 'smooth'})
    }
  }
}
</script>
<style lang="scss" scoped>
.ohelvas-icon {
  position: absolute;
  top: 16px;
  left: 20px;
  right: 20px;
  width: 40px;
  z-index: 10;
}
.header {
  width: 100%;
  display: flex;
  position: relative;
  z-index: 5;
  min-height: 100vh;
  .sidebar {
    background-color: #f6b92f;
    display: flex;
    align-items: center;
    position: absolute;
    z-index: 5;
    height: 100%;
    width: fit-content;
    width: 340px;
    transform: translateX(-260px);
    transition: all 0.5s;
    .arrow {
      margin-right: 28px;
      transform: rotateZ(-90deg);
      transition: all 0.5s;
    }
    &:hover {
      transform: translateX(0px);
      .arrow {
        transform: rotateZ(90deg);
      }
    }
    .sidebar-icons-container {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      height: 100%;
      max-height: 250px;
      transition: all 0.5s;
      width: 340px;
      .icon {
        height: 24px;
        width: 24px;
        margin-left: 28px;
      }
      .sidebar-icon-container {
        position: relative;
        cursor: pointer;
        width: fit-content;
      }
      p {
        position: absolute;
        top: 0;
        left: 80px;
        width: 120px;
        line-height: 24px;
        opacity: 0.5;
        color: white;
        &:hover {
          opacity: 1;
        }
      }
    }

    @media (max-width: 600px){
      display: none;
    }
  }

  @media (max-width: 600px){
    min-height: 348px;
    max-height: 348px;
  }
}
.header-interior {
  position: absolute;
  width: 100%;
  height: 100%;
  .background-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
    top: 0;
  }
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #5d503f;
    opacity: 0.7;
  }
  .text-container {
    width: 100%;
    height: fit-content;
    text-align: center;
    position: absolute;
    left: 0; 
    right: 0; 
    top: 0;
    bottom: 100px;
    margin: auto; 
    h1 {
      font-family: Sen;
      font-size: 64px;
      font-weight: bold;
      line-height: 1.2;
      letter-spacing: -1.43px;
      color: #ffffff;
      margin-top: 60px;;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
    }

    @media (max-width: 800px){
      h1 {
        font-size: 48px; 
      }
    }

    @media (max-width: 620px){
      h1 {
        font-size: 32px; 
        margin-top: 30px;
      }

      .icon {
        margin-top: 32px;
      }
    }
  }
  .scroll-down {
    color: white;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    position: absolute;
    right: 5%;
    bottom: 10%;
    cursor: pointer;
    p {
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 800;
      letter-spacing: 1px;
    }
    svg {
      margin-left: 16px;
    }
  }


}
</style>